<mat-checkbox [checked]="categorie.areAllTakenSelected(clientCategorie)"
  [indeterminate]="categorie.areSomeTakenSelected(clientCategorie)"
  (change)="toggleAll($event)"
  color="primary">
  {{categorie.getLabel()}}
</mat-checkbox>
@for (taak of categorie.getTaken(); track taak) {
  <div
    class="taken">
    <mat-checkbox [checked]="clientCategorie.hasTaak(taak.getId())"
      (change)="toggle(taak, $event)"
      color="primary">
      <span>{{taak.getLabel()}}</span>
      @if (taak.getFrequentie()) {
        <span
          class="mat-small frequentie">
          ({{taak.getFrequentie()}})
        </span>
      }
    </mat-checkbox>
  </div>
}
